// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------

import SettingMer from "@/libs/settingMer";

/** 路由前缀（与 EB view/admin settings.js 一致，支持 `import { roterPre } from '@/settings'`） */
export const roterPre = '/admin';

/**
 * 布局与系统配置（默认导出，兼容 `import settings from '@/settings'`）
 */


const Setting= {
    roterPre,

    /**
     * 网页标题
     */
    title: import.meta.env.VITE_APP_TITLE,
    /**
     * 侧边栏主题 深色主题theme-dark，浅色主题theme-light
     */
    sideTheme: 'theme-dark',
    /**
     * 是否系统布局配置
     */
    showSettings: false,
    // 接口请求地址
    apiBaseURL: SettingMer.https,


    /**
     * 是否显示顶部导航
     */
    topNav: false,

    /**
     * 是否显示 tagsView
     */
    tagsView: true,

    /**
     * 是否固定头部
     */
    fixedHeader: false,

    /**
     * 是否显示logo
     */
    sidebarLogo: true,

    /**
     * 是否显示动态标题
     */
    dynamicTitle: false,
};

export default Setting;
